module.exports = __webpack_public_path__ + "static/media/icons.e3d2a84d.svg";